import React from 'react';
import { Route, Routes } from 'react-router-dom';
import MainWrapper from './MainWrapper';
import SummaryPanelPrinting from '../Summary/SummaryPanelPrinting';
import ConfiguratorGuard from '../Configurator/ConfiguratorGuard';
import PromotionsIndex from '../PromotionsIndex/PromotionsIndex';

const Router = () => (
  <MainWrapper>
    <main>
      <Routes>
        <Route path="/:promotionSlug" element={<ConfiguratorGuard />} />
        <Route path="/:promotionSlug/:code" element={<ConfiguratorGuard />} />
        <Route path="/:promotionSlug/:code/summary" element={<SummaryPanelPrinting />} />
        <Route path="/" component={PromotionsIndex} />
      </Routes>
    </main>
  </MainWrapper>
);

export default Router;
